import accounting from 'accounting'
export const ThY = (year: string | number) => Number(year) + 543

export const Money = (money: number | string | null) => {
  if (money === null) {
    return ''
  }
  return accounting.formatMoney(money, {
    symbol: '',
    precision: 2,
  })
}

export const Num = (number: string | number) => Number(number).toLocaleString()

export const ShortMoney = (number: number | string) => {
  const _number = Number(number)
  if (!_number) {
    return '0'
  }
  // Define an array of suffixes for different magnitudes
  const suffixes = ['', 'K', 'M', 'B', 'T']

  // Find the magnitude of the number (how many digits are there)
  const magnitude = Math.floor(Math.log10(_number))

  // Determine the index of the suffix to use based on the magnitude
  const suffixIndex = Math.floor(magnitude / 3)

  // Calculate the formatted number by dividing by 1000 raised to the power of the suffixIndex
  const formattedNumber = (_number / Math.pow(1000, suffixIndex)).toFixed(2)

  // Append the suffix
  const suffix = suffixes[suffixIndex]

  return `${formattedNumber}${suffix}`
}
